/** The document kinds Support issues: a file sent with a ticket message (kept in Files, not offered for public download). The label is `support.documentKinds.SUP`. */
const SUPPORT_DOCUMENT_KINDS = ["SUP"] as const;
export const supportDocumentKinds = SUPPORT_DOCUMENT_KINDS.map((kind) => ({ kind, labelKey: `support.documentKinds.${kind}` }));
